import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import {
  DefaultErrorMessage,
  UpdateDataSuccessfully,
} from "shared/constants/define-localization";
import { CoreResource, t } from "shared/plugins/localization";
import { createOrderPackingListApi } from "states/order-packing-list/order-packing-list.api";
import { CreatedOrderPackingListItemModel } from "states/order-packing-list/order-packing-list.models";
import {
  OrderModel,
  OrderPackingListItemModel,
  OrderPackingListModel,
  OrderShippingConst,
} from "states/order/order.models";

export interface IOrderShippingButtonProps {
  order: OrderModel;
  handleCreatePackingList: (model: OrderPackingListModel) => void;
  onSuccess: () => void;
}

export function OrderShippingButton(props: IOrderShippingButtonProps) {
  const { order, handleCreatePackingList, onSuccess } = props;

  const handleChangeStatusOrderReadyForPickup = async () => {
    Modal.confirm({
      title: "Xác nhận",
      icon: <ExclamationCircleOutlined />,
      content: "Bạn có chắc muốn chuyển trạng thái sang đang giao?",
      okText: "Ok",
      cancelText: "Bỏ qua",
      onOk: onSubmit,
    });
  };

  const onSubmit = async () => {
    try {
      const packingListItems: CreatedOrderPackingListItemModel[] = [];
      order.orderItems.forEach((orderItem) => {
        packingListItems.push({
          orderItemId: orderItem.id,
        });
        orderItem.modifiers.forEach((modifier) => {
          packingListItems.push({
            orderItemId: modifier.id,
          });
        });
      });
      await createOrderPackingListApi({
        orderPackingListItems: packingListItems,
        orderPackingListId: order.orderPackingLists[0].id,
        collectionAmount: 0,
        customerPayFee: false,
        fee: 0,
        shippingCompanyCode: "",
      });
      Modal.success({
        title: "Thông báo",
        content: "Cập nhật thành công",
        afterClose: () => {
          onSuccess();
        },
      });
    } catch (error: any) {
      Modal.error({
        title: "Thông báo",
        content:
          error?.response?.data?.error?.message ??
          "Lỗi hệ thống",
      });
    }
  };

  return order.orderPackingLists[0].type ===
    OrderShippingConst.shippingType.delivery ? (
    <Button
      block
      type="primary"
      onClick={() => {
        const packingListItems: OrderPackingListItemModel[] = [];
        order.orderItems.forEach((orderItem) => {
          packingListItems.push({
            orderItemId: orderItem.id,
            product: orderItem.product,
            shippedQuantity: orderItem.quantity,
          } as OrderPackingListItemModel);
          orderItem.modifiers.forEach((modifier) => {
            packingListItems.push({
              orderItemId: modifier.id,
              product: modifier.product,
              shippedQuantity: modifier.quantity,
            } as OrderPackingListItemModel);
          });
        });
        handleCreatePackingList({
          id: order.orderPackingLists[0].id,
          orderId: order.id,
          type: order.orderPackingLists[0].type,
          status: order.orderPackingLists[0].status,
          billOfLadingCode: order.orderPackingLists[0].billOfLadingCode,
          confirmedPickupTime: order.orderPackingLists[0].confirmedPickupTime,
          requestedPickupTime: order.orderPackingLists[0].requestedPickupTime,
          shippingAddress: order.orderPackingLists[0].shippingAddress,
          shippingCompanyCode:
            order.orderPackingLists[0].type ===
            OrderShippingConst.shippingType.delivery
              ? OrderShippingConst.ShippingCompany.other
              : undefined,
          orderPackingListItems: packingListItems,
          collectionAmount: 0,
        });
      }}
    >
      Giao hàng
    </Button>
  ) : (
    <Button
      block
      type="primary"
      onClick={() => {
        handleChangeStatusOrderReadyForPickup();
      }}
    >
      Sẵn sàng để nhận
    </Button>
  );
}
